import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Kontor } from '@store/models';

@Component({
    selector: 'app-switchoffice-ui',
    templateUrl: './switchoffice.component.html',
    standalone: false
})

export class SwitchOfficeComponent {

    @Input() offices: Kontor[];
    @Output() switchOffice = new EventEmitter<Kontor>();
    @Output() dismiss = new EventEmitter();

    onSwitchOffice(office: Kontor) {
        this.switchOffice.emit(office);
    }

    onDismiss() {
        this.dismiss.emit();
    }

}
